(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function lsHelper() {
  var self = this;

  this.updateProduct = function (id, qty) {
    var localStorageBasket = localStorage.getItem('bascket');

    if (localStorageBasket) {
      var basket = JSON.parse(localStorageBasket);
      var newBasket = {
        total: 0.00,
        subTotal: 0.00,
        delivery: 0.00,
        products: []
      };
      var availableProducts = [];

      for (var i = 0; i < basket.products.length; i++) {
        var localStorageProduct = basket.products[i];

        if (localStorageProduct.id === id) {
          if (qty !== 0) {
            localStorageProduct.qty = qty;
            availableProducts.push(localStorageProduct);
          }
        }
      }

      newBasket.products = availableProducts;
      var subTotal = 0;

      for (var i = 0; i < availableProducts.length; i++) {
        var localStorageProduct = availableProducts[i];
        subTotal = subTotal + localStorageProduct.price * localStorageProduct.qty;
      }

      newBasket.subTotal = subTotal;
      newBasket.total = newBasket.subTotal + newBasket.delivery;
      localStorage.setItem('bascket', JSON.stringify(newBasket));
    }
  };

  this.clearBasket = function () {
    localStorage.removeItem('bascket');
  };

  this.generateDeviceId = function () {
    if (localStorage.getItem("deviceId") != null) {
      _deviceId = localStorage.getItem("deviceId");
    } else {
      var rand = Math.random;
      var randomNumber,
          randomString = "";

      do {
        randomString += (randomNumber = rand()).toString(16).substr(3, 6);
      } while (randomString.length < 30);

      var guid = randomString.substr(0, 8) + "-" + randomString.substr(8, 4) + "-4" + randomString.substr(12, 3) + "-" + ((randomNumber * 4 | 0) + 8).toString(16) + randomString.substr(15, 3) + "-" + randomString.substr(18, 12);
      localStorage.setItem("deviceId", guid);
      _deviceId = localStorage.getItem("deviceId");
    }
  };

  this.loginUser = function (email, password) {
    authenticateService().login(email, password).done(function (responseData) {
      authenticateProfile().setToken(responseData.access_token, responseData.refresh_token).done(function (user) {});
    }).fail(function (res) {});
  };

  return {
    updateProduct: self.updateProduct,
    clearBasket: self.clearBasket,
    generateDeviceId: self.generateDeviceId,
    loginUser: self.loginUser
  };
}

},{}]},{},[1]);
